<template>
  <a-card title="测试批次管理">
    <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
      <a-form-item>
        <a-input allowClear=true placeholder="批次ID" v-model:value="formSearch.batch_id" />
      </a-form-item>
     <a-form-item  label="工具类型"  name="tool_id">
        <a-select
            :allowClear="true"
            show-search
            option-filter-prop="label"
            style="width: 100px;"
          v-model:value="formSearch.tool_id"
          :options="ToolIDOptions"
        />
      </a-form-item>
      <a-form-item  label="任务类型"  name="style_id">
        <a-select
            :allowClear="true"
            show-search
            option-filter-prop="label"
            style="width: 230px;"
          v-model:value="formSearch.style_id"
          :options="TaskStyleGroupOptions"
        />
      </a-form-item>
      <a-form-item label="执行人">
        <a-input allowClear=true placeholder="执行人 ID（默认当前登录用户）" v-model:value="formSearch.operator_id" />
      </a-form-item>
      <a-form-item>
        <a-space>
          <a-button
          type="primary"
          html-type="submit"
          @click="handleTableChange()"
          shape="circle"
        >
        <template #icon><SearchOutlined /></template>
        </a-button>
        </a-space>
      </a-form-item>
     
    </a-form>
  
    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
      <a-table 
    class="ant-table-striped"
    show-quick-jumper
    :row-key="record => record.id"
    :data-source="dataSource" 
    :columns="columns" 
    :pagination="pagination"
    :loading="loading"
    @change="handleTableChange"
    :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
    >
      <template #operator_id="{ record }">
        <Username :user_id="record.operator_id" />
      </template>
      <template #style_id="{ record }">
        <a-tag color="blue" >{{  StyleFlowNames[record.style_id]  }}</a-tag>
      </template>
      <template #status="{ record }">
        <a-tag v-if="record.status == 4" color="red" >已终止</a-tag>
        <a-tag v-else-if="record.total_count == record.executed_count" color="green" >已结束</a-tag>
        <a-tag v-else >正常</a-tag>
      </template>
      <template #action="{ record }">
        <a-space>
          <a-button type="primary"  @click="handleDetail(record)">详情</a-button>
          <TestcaseRun
            :case="{}"
            :btnText="'Case 克隆' + '(' + record.total_count + ')' "
            :style="StyleFlowNames[record.style_id]"
            :batchBy="{
              batch_id: record.id,
            }"
          />

          <a-popconfirm
            title="确认重跑该批次吗？确认后会创建一个新的测试批次"
            ok-text="确定"
            cancel-text="不了"
            @confirm="handleRerun(record)"
          >
            <a-button  :loading="record.loading"  danger >重试</a-button>
          </a-popconfirm>
          <a-popconfirm
            title="确认删除该批次吗？仅删除批次记录，不会删除关联测试任务。"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a-button danger>删除</a-button>
          </a-popconfirm>
       </a-space>
      </template>
    </a-table>
  </a-card>

</template>
<script>
import { defineComponent,  h,onMounted} from 'vue'
import { Modal, message } from 'ant-design-vue';

import { SearchOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'
import { useStore } from 'vuex'
import {useRoute} from 'vue-router'
import {Operators} from '@/utils/macro'
import TestcaseRun from '@/components/TestcaseRun.vue'

import Username from '@/components/Username.vue'
import { TaskStyleGroupOptions, StyleFlowNames, ToolIDOptions} from '@/utils/macro'

export default defineComponent({
  components: {
    SearchOutlined,
    Username,
    TestcaseRun,
  },
  data(){
    const store = useStore()
    return {
      loading: false,
      dataSource: [],
      pageNo: 0,
      StyleFlowNames,TaskStyleGroupOptions,
      ToolIDOptions,
      Operators,
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-quick-jumper': true,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '性能问题，总条数不再展示',

       formSearch: {
        operator_id: store.state.user.user_id,
        tool_id: '',
        style_id: '',
        batch_id: '',
      },

      uploadLoading: false,
    }
  },
  mounted(){
    const route = useRoute()
    if (route.query['label_id']) {
      this.formSearch.label_id = route.query['label_id']
    }

    this.handleTableChange()
  },
  computed:{
  },
  methods: {
    handleDetail(record){
      this.$router.push({path: '/home/testcase/tasks', query: {batch_id: record.id}})

    },
    async handleRerun(record){
      record.loading = true
      const rsp = await request.post(`/api/testcase/batches/${record.id}/retry`, {  })
      record.loading = false
      if(rsp.code == 0) {
         this.$router.push({path: '/home/testcase/tasks', query: {batch_id: rsp.data.batch_id}})
      } else {
        message.error(rsp.message)
      }

    },
    async handleDelete(record) {
      this.loading = true
      try {
        const rsp = await request.delete(`/api/testcase/batches/${record.id}`)
        if (rsp.code === 0) {
          message.success('批次已删除')
          this.handleTableChange({ ...this.pagination })
        } else {
          message.error(rsp.msg)
        }
      } finally {
        this.loading = false
      }
    },
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
     
      let limit = pagi.pageSize
      let orderBy = "id desc"
      let offset =  (pagi.current - 1) * pagi.pageSize
      const rsp = await request.get('/api/testcase/batches/', {
        offset: offset,
        limit: limit,
        order_by: orderBy,
        ...this.formSearch,
        // after_cursor: afterCursor,
        // before_cursor: beforeCursor,
      })
      this.loading = false
      this.dataSource = [].concat(rsp.data.list)
      
      for(let item of this.dataSource) {
        item.created_at = new Date(item.created_at).toLocaleString()
        item.updated_at = new Date(item.updated_at).toLocaleString()
      }
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`

      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
    
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
      columns: [
      {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: '名称',
          dataIndex: 'batch_name',
          key: 'batch_name',
          width:200,
        },
        {
          title: '类型',
          dataIndex: 'style_id',
          key: 'style_id',
          slots: { customRender: 'style_id' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          slots: { customRender: 'status' },
        },
        {
          title: '总数',
          dataIndex: 'total_count',
          key: 'total_count',
        },
         {
          title: '运行次数',
          dataIndex: 'executed_count',
          key: 'executed_count',
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
          // slots: { customRender: 'created_at' },
        },
        {
          title: '操作人',
          dataIndex: 'operator',
          key: 'operator',
          slots: { customRender: 'operator_id' },
        },
         {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}

.thumbnail-wraps {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.prompt-container {
  cursor: pointer;
  max-height: 350px;
  max-width: 100px;
  overflow-y: scroll;
}
.prompt-container:hover {
  color: red;
}
.thumbnail-item {
  display: inline-block;
  /* flex-direction: row; */
  width: 180px;
  margin: 2px;
}
</style>
